<template>
  <div v-show="isShow" class="invalidTablet">
    <div class="invalidTablet__en">Please use a dedicated tablet.</div>
    <div class="invalidTablet__ja">専用タブレットをお使いください。</div>
  </div>
</template>

<script>
export default {
  name: "InvalidTablet",
  computed: {
    isShow() {
      return !this.$store.state.device.tablet;
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
.invalidTablet
    position: fixed
    @include fit
    z-index: $z_notify_invalid_tablet
    background-color: #000
    @include flexCenter
    @include flexVertical
    .invalidTablet__en
      margin-bottom: 1em

</style>
